import { toast } from "react-toastify";
import axios from "axios";
import settings from "utils/settings";
import { requestCommonFilters, requestCommonSearch } from "actions/common/requests";
import defaultErrorHandler from "actions/global/default-error-handler";
import filterTypes from "data/filter-types";

import {
  ADMIN_LOADING,
  ADMIN_ERROR,

  ADMIN_ROLES,
  ADMIN_FILTERS,
  ADMIN_LIST,
  ADMIN_DELETE
} from "./constants";

const apiURL = `${settings.apiUrl}api/`;
const ENDPOINT = "admin";

export const setLoading = (status) => ({
  type: ADMIN_LOADING,
  payload: status
});

export const getRoles = () => dispatch => {
  dispatch(setLoading(true));
  axios.get(`${apiURL}${ENDPOINT}/roles`)
    .then((response) => {
      dispatch({
        type: ADMIN_ROLES,
        payload: response.data.content
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, ADMIN_ERROR));
    });
};

export const getFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters(ENDPOINT)
    .then((response) => {
      dispatch({
        type: ADMIN_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, ADMIN_ERROR));
    });
};

export const search = (page = 0, size = 20, sort = "name,asc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, page, size, sort, filters)
    .then(response => {
      dispatch({
        type: ADMIN_LIST,
        payload: response
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ADMIN_ERROR));
    });
};

export const findById = (id, callback) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, 0, 1, "", [{
    fieldName: "id",
    fieldValue: id,
    searchOperation: filterTypes.EQUALS.value
  }])
    .then(response => {
      callback(response.content ? response.content[0] : {});
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ADMIN_ERROR));
    });
};

export const addItem = (data, callback) => dispatch => {
  setLoading(true);
  axios.post(`${apiURL}${ENDPOINT}`, data)
    .then(() => {
      toast("New admin created successfully", {
        type: toast.TYPE.SUCCESS,
      });
      callback();
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ADMIN_ERROR));
    });
};

export const updateItem = (id, data, callback) => dispatch => {
  setLoading(true);
  axios.put(`${apiURL}${ENDPOINT}/${id}`, data)
    .then(() => {
      toast("Admin data updated successfully", {
        type: toast.TYPE.SUCCESS,
      });
      callback();
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ADMIN_ERROR));
    });
};

export const deleteItem = id => dispatch => {
  setLoading(true);
  axios.delete(`${apiURL}${ENDPOINT}/${id}`)
    .then(() => {
      dispatch({
        type: ADMIN_DELETE,
        payload: id
      });
      toast("Admin deleted successfully", {
        type: toast.TYPE.SUCCESS,
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ADMIN_ERROR));
    });
};

export const getAdminsByRole = (role, callback) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, 0, 1000000, "name,asc", [{
    fieldName: "roles",
    fieldValue: [role],
    searchOperation: filterTypes.EQUALS.value
  }])
    .then(response => {
      callback(response.content ? response.content : []);
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, ADMIN_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/admin/actions.js